import React from "react";
import { Select } from "@jsq/ds/core";
import type { FieldEditorProps } from "./types";

/**
 * Enumeration Field Editor Component
 *
 * Specialized select component for enumeration extension fields.
 * Provides dropdown selection with enum values and design system styling.
 */
export const EnumerationFieldEditor: React.FC<FieldEditorProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
}) => {
  const enumOptions = field.activeEnumValues || field.enumValues || [];

  const handleChange = (selectedValue: string | number | string[] | number[]) => {
    // Convert to string since our FieldEditorProps expects string
    onChange(String(selectedValue));
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      disabled={disabled}
      error={error || undefined}
      full
      placeholder="Select an option"
      data-testid="enumeration-field-editor"
    >
      <Select.Section>
        {enumOptions.map((enumValue) => (
          <Select.Option key={enumValue.id} value={enumValue.enumValueCode}>
            {enumValue.enumValueLabel}
          </Select.Option>
        ))}
      </Select.Section>
    </Select>
  );
};

export default EnumerationFieldEditor;
